import axios from '../../axios';

const path = '/breeding';

const service = {
  createBreedings(data) {
    return axios.request({ method: 'post', url: `${path}/store/bulk`, data: { breeding_events: data } });
  },

  fetchBreeding(params) {
    return axios({ method: 'get', url: `${path}/index`, params });
  },

  fetchBreedingEventTypes() {
    return axios({ method: 'get', url: `${path}/event-types` });
  },

  fetchBreedingEventStatus() {
    return axios({ method: 'get', url: `${path}/event-status` });
  },

  updateBreeding({ id, data }) {
    return axios.request({ method: 'put', url: `${path}/${id}`, data });
  },

  deleteBreedings(ids) {
    return axios({ method: 'delete', url: `${path}/destroy_bulk`, data: { ids } });
  }
};

export default service;
